// Shared sign-out helper. Used by the header pill, the idle-logout watchdog,
// and any future "session expired" flows. Clears the JWT from localStorage,
// drops the guest flag, fires the `atrium:auth-changed` event so reactive
// auth-state listeners (e.g. App.js userRole/adminToken) immediately refresh,
// and routes to the auth gate.
export function signOut(reason = null) {
  try {
    localStorage.removeItem('admin_token');
    localStorage.removeItem('user_email');
    localStorage.removeItem('user_role');
    sessionStorage.removeItem('atrium_guest');
    if (reason) sessionStorage.setItem('atrium_signout_reason', reason);
    // iter-79: notify in-tab listeners (the `storage` event only fires
    // cross-tab, so without this anything inside the same tab that
    // cached auth values at mount would never know we logged out).
    window.dispatchEvent(new CustomEvent('atrium:auth-changed'));
  } catch (e) { /* ignore */ }
  window.location.href = '/';
}

// Is there a real signed-in user? (Guests don't get auto-logged-out for idle.)
export function isAuthenticatedUser() {
  if (typeof window === 'undefined') return false;
  return !!localStorage.getItem('admin_token');
}
